import Bugsnag from "@bugsnag/js";
import { getQueryParams } from "@/utils/httpRequest";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_SERVICE_TAG } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const getLendingProgramsEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    getLendingPrograms: builder.query({
      query: ({ params }) => `lending-programs?${getQueryParams(params)}`,
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(({ lendingProgramId }) => ({
                type: LENDING_PROGRAM_SERVICE_TAG,
                id: lendingProgramId,
              })),
              { type: LENDING_PROGRAM_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: LENDING_PROGRAM_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted({ params, setParams }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (!data.items.length && params.page > 1) {
            setParams((prev) => ({ ...prev, page: prev.page - 1 }));
          }
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetLendingProgramsQuery } = getLendingProgramsEndpoint;

